import intl from 'react-intl-universal'

export default {
  type: 'loadFailure',
  title: `Embed Load Failure`,
  icon: `exclamation-triangle`,
  template: `
      <div contenteditable="false" class="alert alert-danger">
        {{feature.referent.type}} ${intl.get('blocks.reference.errors.header')}
      </div>
    `,
}
